import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_Link, ValidateHeader } from "../../common/Constants";

export const getCountriesSlice = createApi({
  reducerPath: 'getCountries',
  baseQuery: fetchBaseQuery({
    baseUrl: API_Link, // Use your API base URL
    prepareHeaders: (headers, { getState }) => {
      // Access the Redux state
      const token = getState().user?.user?.token;
      headers.set('Content-Type', 'application/json');
      headers.set('Accept', 'application/json');
      headers.set('plims-auth', ValidateHeader);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: () => 'getCountry',
      transformResponse: (response) => response.country.data, // Adjust this if necessary
      cacheTime: Infinity,
    }),
  }),
});

export const { useGetCountriesQuery } = getCountriesSlice;
